const CONSTANTS = {
  PRODUCT_TYPE: {
    '开发者': 0,
    '团队': 1,
    '企业': 2
  },
  MONTH: {
    1: '1个月',
    3: '3个月',
    6: '6个月',
    12: '12个月',
    36: '36个月'
  }
}

export default CONSTANTS